<script setup lang="ts">
// 1:1 Port von club-offering/src/app/app.component.
import { computed } from 'vue';
import ActiveWaitListEntries from '@shared/components/offering/ActiveWaitListEntries.vue';
import AppHeader from './components/core/AppHeader.vue';
import LoginStatus from './components/core/LoginStatus.vue';
import { useAppStateStore } from '@shared/stores/app-state';
import { useUserStore } from '@shared/stores/user';

const userStore = useUserStore();

// Angular: `showHeader = appStateService.isInIframe === false`, gesetzt EINMAL in ngOnInit.
const showHeader = !useAppStateStore().isInIframe;

// Das Warteliste-Banner zeigt Angular nur eingeloggt — der anonyme Gast sieht es nie.
const isLoggedIn = computed(() => userStore.isLoggedIn && !!userStore.currentUser);
</script>

<template>
    <div
        class="appShell"
        :class="{ 'has-header': showHeader }"
    >
        <AppHeader v-if="showHeader" />

        <LoginStatus class="kgr-screenMargin kgr-row" />

        <ActiveWaitListEntries v-if="isLoggedIn" />

        <!-- Portal-Ziel von KgrPageTitle (Teleport to="#kgr-pageTitle"), Pendant zu Angulars
             DomPortalOutlet(document.getElementById('kgr-pageTitle')). Die Klassen stammen
             unveraendert aus app.component.html. -->
        <div
            id="kgr-pageTitle"
            class="kgr-screenMargin kgr-headline kgr-headline--h2"
        ></div>

        <RouterView />
    </div>
</template>

<style scoped>
/* Angular: :host { display: block; &.has-header { --kgr-pageLayout-header-height: 80px } } */
.appShell {
    display: block;
}

.appShell.has-header {
    --kgr-pageLayout-header-height: 80px;
}

/* Angular: #kgr-pageTitle:empty { display: none } */
#kgr-pageTitle:empty {
    display: none;
}
</style>
